import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSnackbar } from '@/contexts/SnackbarContext';
import { useAuth0 } from '@auth0/auth0-react';
const LoginPage = () => {
    const { loginWithRedirect } = useAuth0();
    const [searchParams] = useSearchParams();
    const { showError } = useSnackbar();
    useEffect(() => {
        const error = searchParams.get('error');
        if (error)
            showError(error);
    }, [searchParams, showError]);
    return (_jsxs("div", { className: "app flex flex-col items-center justify-center min-h-screen", children: [_jsx("header", { className: "app-header mb-8", children: _jsx("h1", { className: "text-3xl font-bold", children: "Kasm License Management" }) }), _jsx("button", { "data-testid": "login-link", onClick: () => loginWithRedirect(), className: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded", children: "Login" })] }));
};
export default LoginPage;
